import React, { JSX } from "react";
import { ReactComponent as MonoLogo } from "assets/images/banks/mono-logo.svg";
import { ReactComponent as PrivatLogo } from "assets/images/banks/privat-logo.svg";
import { ReactComponent as PrivatBusinessLogo } from "assets/images/banks/privat24business-logo.svg";
import { ReactComponent as ABankLogo } from "assets/images/banks/abank-logo.svg";
import { ReactComponent as PumbLogo } from "assets/images/banks/pumb-logo.svg";
import { ReactComponent as SenseLogo } from "assets/images/banks/sense-logo.svg";
import { ReactComponent as UkrsibbankLogo } from "assets/images/banks/ukrsibbank-logo.svg";
import { ReactComponent as RaiffeisenLogo } from "assets/images/banks/raiffeisen-logo.svg";
import { ReactComponent as UkrGasLogo } from "assets/images/banks/ukrgas-logo.svg";
import { ReactComponent as IziLogo } from "assets/images/banks/izi-logo.svg";
import { ReactComponent as CreditDniproLogo } from "assets/images/banks/credit-dnipro-logo.svg";
import { ReactComponent as GlobusLogo } from "assets/images/banks/globus-logo.svg";
import { ReactComponent as AgricoleLogo } from "assets/images/banks/agricole-logo.svg";
import { ReactComponent as OtpLogo } from "assets/images/banks/otp-logo.svg";
import { ReactComponent as VostokLogo } from "assets/images/banks/vostok-logo.svg";
import { ReactComponent as KredoLogo } from "assets/images/banks/kredobank-logo.svg";

export enum IbanKeys {
  PREFERRED_ACCOUNT_UID = "PREFERRED_ACCOUNT_UID",
  PREFERRED_BANK = "PREFERRED_BANK",
}

export interface Bank {
  logo: JSX.Element;
  name: string;
  shortName: string;
  packageAndroid: string;
  packageIOS: string;
  universalLinkIOS?: string;
}

export const banks: Bank[] = [
  {
    logo: <MonoLogo />,
    name: "Mono",
    shortName: "mono",
    packageAndroid: "com.ftband.mono",
    packageIOS: "mono", // com.ftband.mono
  },
  {
    logo: <PrivatLogo />,
    name: "Приват24",
    shortName: "privat24",
    packageAndroid: "ua.privatbank.ap24",
    packageIOS: "privat24", // https://www.privat24.ua/rd/send_qr/https
  },
  {
    logo: <PrivatBusinessLogo />,
    name: "Privat24 for business",
    shortName: "privat24business",
    packageAndroid: "ua.privatbank.cb",
    packageIOS: "", // p24business // p24businessShared
  },
  {
    logo: <KredoLogo />,
    name: "KredoBank",
    shortName: "kredobank",
    packageAndroid: "ua.android.kredobank.prod",
    packageIOS: "", // ua.com.kredobank.ios
  },
  {
    logo: <ABankLogo />,
    name: "Абанк",
    shortName: "abank",
    packageAndroid: "ua.com.abank",
    packageIOS: "abank24", // abank24 // com.abank24.mobapplication
  },
  {
    logo: <PumbLogo />,
    name: "Пумб",
    shortName: "pumb",
    packageAndroid: "", // com.fuib.android.spot.online
    packageIOS: "", // fuib.pumb-ispot
    universalLinkIOS: "https://mobile-app.pumb.ua/bank.gov.ua",
  },
  {
    logo: <SenseLogo />,
    name: "Sense Bank",
    shortName: "sensebank",
    packageAndroid: "ua.alfabank.mobile.android",
    packageIOS: "", // ua.alfabank.mobile.ios
  },
  {
    logo: <UkrsibbankLogo />,
    name: "Ukrsibbank",
    shortName: "ukrsibbank",
    packageAndroid: "com.ukrsibbank.uso.android",
    packageIOS: "com.ukrsibbank.ukrsibonline.new", //
  },
  {
    logo: <RaiffeisenLogo />,
    name: "Raiffeisen",
    shortName: "raiffeisenbank",
    packageAndroid: "ua.raiffeisen.myraif",
    packageIOS: "myraif", // myraif // ua.raiffeisen.myraif
  },
  {
    logo: <UkrGasLogo />,
    name: "Укргазбанк",
    shortName: "ukrgasbank",
    packageAndroid: "com.ugb.app",
    packageIOS: "ecobank", // ecobank // ugb.ugb-banking-ios.release
  },
  {
    logo: <IziLogo />,
    name: "izibank",
    shortName: "izibank",
    packageAndroid: "ua.izibank.app",
    packageIOS: "", // izibank // izibank.ua.app
  },
  {
    logo: <CreditDniproLogo />,
    name: "Банк Кредит Дніпро",
    shortName: "creditdnepr",
    packageAndroid: "com.creditdnepr.mb",
    packageIOS: "", // freebank // com.creditdnepr.freebank
  },
  {
    logo: <GlobusLogo />,
    name: "Глобус Банк",
    shortName: "globus",
    packageAndroid: "com.t18.bone.personal.globus",
    packageIOS: "", // com.t18.bone.personal.globus
  },
  {
    logo: <AgricoleLogo />,
    name: "Креді Агріколь Банк",
    shortName: "creditagricole",
    packageAndroid: "ua.creditagricole.mobile.app",
    packageIOS: "", // ua.creditagricole.mobile.app
    universalLinkIOS: "https://caplusapp.credit-agricole.ua",
  },
  {
    logo: <OtpLogo />,
    name: "ОТП БАНК",
    shortName: "otpbank",
    packageAndroid: "ua.otpbank.android",
    packageIOS: "otpbankua", // ua.otpbank.ios
  },
  {
    logo: <VostokLogo />,
    name: "Банк Восток",
    shortName: "vostok",
    packageAndroid: "com.vostok.bv",
    packageIOS: "vostok", // com.vostok.BV
  },
];
